export const normalizeAtPathForRouter = (pathname: string) =>
  pathname.replace(/\/@([^/]+)/g, '/@/$1')

export const normalizeAtPathForBrowser = (pathname: string) =>
  pathname.replace(/\/@\/([^/]+)/g, '/@$1')
